import { useContext, useState } from "react";
import ScrollAnimation from "react-animate-on-scroll";
import { Accordion } from "react-bootstrap";
import { useAccordionButton } from "react-bootstrap/AccordionButton";
import AccordionContext from "react-bootstrap/AccordionContext";
import CourseData from "../../data/course/CourseData.json";
import CurriculumTabContent from "../../data/course/CurriculumTabContent.json";
import InstructorData from "../../data/instructor/InstructorData.json";
import { slugify } from "../../utils";

const CustomToggle = ({ children, eventKey }) => {
  const { activeEventKey } = useContext(AccordionContext);
  const decoratedOnClick = useAccordionButton(eventKey);
  const isCurrentEventKey = activeEventKey === eventKey;
  return (
    <button
      type="button"
      onClick={decoratedOnClick}
      aria-expanded={isCurrentEventKey ? true : false}
      className="edu-accordion-button"
    >
      {children}
    </button>
  );
};

const CurriculumContent = () => {
  const [activeId, setActiveId] = useState("0");

  function toggleActive(id) {
    if (activeId === id) {
      setActiveId(null);
    } else {
      setActiveId(id);
    }
  }

  return (
    <Accordion bsPrefix="edu-accordion-02" defaultActiveKey={activeId} flush>
      {CurriculumTabContent.map((accordion, i) => (
        <Accordion.Item
          eventKey={i.toString()}
          key={i}
          onClick={() => toggleActive(i.toString())}
          bsPrefix={`edu-accordion-item ${
            activeId === i.toString() ? "bg-active" : ""
          }`}
        >
          <div className="edu-accordion-header">
            <CustomToggle eventKey={i.toString()}>
              {accordion.title}
            </CustomToggle>
          </div>
          <Accordion.Body bsPrefix="edu-accordion-body">
            <ul>
              {accordion.content.map((title, index) => (
                <li key={index}>
                  <div className="text">
                    <i className="icon-draft-line"></i>
                    {title}
                  </div>
                  <div className="icon">
                    <i className="icon-lock-password-line"></i>
                  </div>
                </li>
              ))}
            </ul>
          </Accordion.Body>
        </Accordion.Item>
      ))}
    </Accordion>
  );
};

const KYouthProgrammeDetails = () => {
  const courseItem = CourseData[0];

  const indexOfInstructor = InstructorData.findIndex(function (instructor) {
    return slugify(instructor.name) === slugify(courseItem.instructor);
  });
  const instructor = InstructorData[indexOfInstructor];
  const instructorExcerpt = instructor.details.substring(0, 157) + "...";

  return (
    <div className="edu-course-details-area">
      <div className="row g-5">
        <ScrollAnimation
          animateIn="fadeInUp"
          animateOut="fadeInOut"
          className="read-more-btn"
          animateOnce={true}
        >
          <div className="col-xl-12 col-lg-12">
            <div className="course-details-content">
              <h4
                className="color-white"
                style={{
                  fontSize: 20,
                  // fontWeight: 900,
                  backgroundColor: "var(--color-contrast)",
                  padding: "10px 18px",
                }}
              >
                HOST COMPANY APPLICATION FOR PROFESSIONAL APPRENTICES
              </h4>
              <ul>
                <li style={{ color: "var(--color-white)" }}>
                  Offer placement opportunities to trained Diploma and Degree
                  graduates up to 4 months.
                </li>
                <li style={{ color: "var(--color-white)" }}>
                  Monthly allowance of RM 2,000 (Diploma) and RM 2,300 (Degree),
                  inclusive of EPF & SOCSO.
                </li>
                <li style={{ color: "var(--color-white)" }}>
                  Committed towards offering On-The-Job training in Digital &
                  Technology roles with AI upskilling opportunities.
                </li>
              </ul>
              <div className="color-white">
                <div>
                  <b>LIMITED TALENTS AVAILABLE</b>
                </div>
                Only eligible companies will be notified
              </div>
            </div>
          </div>
        </ScrollAnimation>
      </div>
    </div>
  );
};
export default KYouthProgrammeDetails;
